import React, { useEffect, useState } from "react";
import "chart.js";

import TaskItem from "./dashboard/task-item";

import { getTaskMetrics } from "./dashboard/lib/dashboard-data";
import { taskDefinitions } from "../components/task-status/lib/constants";

const AdminIndex = () => {
    const [data, setData] = useState({});
    useEffect(() => {
        async function init() {
            const dashData = await getTaskMetrics();

            if (!dashData) {
                return;
            }

            setData(dashData);
        }

        init();
    }, []);
    const taskOrder = Object.keys(taskDefinitions).map((key) => key);
    const taskItems = Object.keys(data)
        .filter((taskKey) => taskKey in taskDefinitions)
        .sort((a, b) => taskOrder.indexOf(a) - taskOrder.indexOf(b))
        .map((key) => {
            return <TaskItem key={`taskItem_${key}`} taskKey={key} data={data[key]} taskDefinition={taskDefinitions[key]}/>;
        });

    return (
        <div>
            <h1>Dashboard</h1>
            {taskItems}
        </div>
    );
};

export default AdminIndex;
